export const enI18n = {
  service_consult_fox: "WhatsApp",
  service_consult: "Online consult",
  service_email: "Service email",
  service_24_hour: "24 hour national service hotline",
  service_contact_email: "service@foxrenderfarm.com",
  service_contact: "400-003-4560",
  private_manager: "Account Manager",
};
export const zhI18n = {
  service_consult_fox: "WhatsApp",
  service_consult: "在线咨询",
  service_email: "服务邮箱",
  service_24_hour: "24小时全国服务热线",
  service_contact_email: "service@foxrenderfarm.com",
  service_contact: "400-003-4560",
  private_manager: "专属商务对接",
};

export const getTranslateNsT = (local: "zh" | "en") => {
  return (key: string) =>
    ({
      zh: zhI18n,
      en: enI18n,
    }[local][key] || "");
};
